import precedaApi from '../api/precedaApi'

export default {
    async fetchContractorOrganisations(){
        return await precedaApi.getContractorOrganisations();
    },
    async fetchTeams(){
        return await precedaApi.getTeams();
    },
    async downloadContractorExport(contractorOrganisationID, startDate, endDate){
        await precedaApi.downloadContractorExport(contractorOrganisationID, startDate, endDate);
    },
    async fetchCropWorkPreview(contractorOrganisationID, teamName, startDate, endDate){
        return await precedaApi.getCropWorkPreview(contractorOrganisationID, teamName, startDate, endDate);
    },
    async downloadCropWorkExport(contractorOrganisationID, teamName, startDate, endDate){
        await precedaApi.downloadCropWorkExport(contractorOrganisationID, teamName, startDate, endDate);
    }
}